import type { DataSchemaServerType } from '@/services/data-schema/dataSchema';
import * as JSONSchemaSampler from '@stoplight/json-schema-sampler';
import * as JSONBigint from '@tarslib/json-bigint';
import { AppJsonSchema2MockJsonSchema } from '@tarslib/utils/lib/json-schema/AppJsonSchema2JsonSchemaStandard';
import traverse from '@tarslib/utils/lib/json-schema/traverse';
import json2xml from '@tarslib/utils/lib/utils/json2xml';
import type { JSONSchema7 } from 'json-schema';
import cloneDeep from 'lodash-es/cloneDeep';
import type { Any } from '../constant/any';

export function generateExampleByJsonSchema(
  jsonSchema: JSONSchema7,
  definitions: DataSchemaServerType,
  isXml: boolean,
  type: 'request' | 'response',
): string {
  const schema: typeof Any = { ...jsonSchema, definitions };

  try {
    const newSchema = AppJsonSchema2MockJsonSchema(schema, [], {
      enableXAppEnum: true,
      enableXAppMock: true,
    });
    const newSchemaCopy = cloneDeep(newSchema);
    traverse(newSchemaCopy, (item) => {
      if (typeof item.minimum === 'number' && typeof item.exclusiveMinimum === 'number') {
        delete item.minimum;
      }

      if (typeof item.maximum === 'number' && typeof item.exclusiveMaximum === 'number') {
        delete item.maximum;
      }
    });

    const json = JSONSchemaSampler.sample(
      newSchemaCopy,
      type === 'request' ? { skipReadOnly: true } : { skipWriteOnly: true },
      newSchemaCopy,
    ) as string;

    if (isXml) {
      return json2xml(json, {
        indent: '  ',
        jsonSchema: schema,
      });
    } else {
      return JSONBigint.stringify(json, null, 4);
    }
  } catch (_e) {
    if (_e) {
      //
    }
    return '';
  }
}
